import React, { Component, useState, Fragment, useEffect, useRef, useMemo } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import GrainIcon from '@mui/icons-material/Grain';
import LightModeIcon from '@mui/icons-material/LightMode';
import Checkbox from '@mui/material/Checkbox';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { AppBar, Toolbar, Typography, Button, IconButton, Modal, Grid, Box, TextField, FormControl, Drawer, Menu, Paper, Select, MenuItem } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Card from '@material-ui/core/Card';
import SearchIcon from '@material-ui/icons/Search';
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import { PostAddOutlined } from '@mui/icons-material';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { customTheme } from '../../../StyleComponents/Styledatatable';
import classNames from 'classnames';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
// import AddUpdateUser from "../AddUpdateUser/AddUpdateUser";
// import SearchUserform from "../SearchUser/SearchUserform";
import useStyles from '../../../StyleComponents/StyleFunctionComponent';
import CircularProgress from '@material-ui/core/CircularProgress';
import AccordionSummary from '@mui/material/AccordionSummary';
import SettingsIcon from '@mui/icons-material/Settings';

import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';

import { API_BASE_URL, token, userLevel, adminId } from '../../../../constants';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

const EicherAPIResponse = () => {
    const history = useHistory();
    const [openSidebar, setOpenSidebar] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [perPage, setPerPage] = useState(50);
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 0);
    const [fromDate, setFromDate] = useState(sevenDaysAgo.toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(currentDate.toISOString().split('T')[0]);
    const [enquirySource, setEnquirySource] = useState([]);
    const [selectedExecutive, setSelectedExecutive] = useState(null);
    const [executiveOptions, setExecutiveOptions] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [appliedFilters, setAppliedFilters] = useState(null);
    const [selectedFinanceIds, setSelectedFinanceIds] = useState([]);
    const [financeDialogOpen, setFinanceDialogOpen] = useState(false);
    const [financeSubmitting, setFinanceSubmitting] = useState(false);
    const [financeError, setFinanceError] = useState('');
    const [financeFilters, setFinanceFilters] = useState({client_name: 'Tyger', state_id: '', start_date: '', end_date: ''});
    const [stateOptions, setStateOptions] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState();
    const [brandOptions, setBrandOptions] = useState([]);
    const [status, setStatus] = useState("success");
    const [viewOpen, setViewOpen] = useState(false);
    const [viewData, setViewData] = useState(null);
    useEffect(() => {
        const fetchDatabrand = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity, // Request will never time out
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.brand_id,
                    title: item.brand_name,
                }));
                setBrandOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatabrand();
    }, []);
    useEffect(() => {
        const fetchDatastate = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity, // Request will never time out
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/state-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.state_id,
                    title: item.state_name,
                }));
                setStateOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatastate();
    }, []);
    useEffect(() => {
        const fetchDatalist = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity, // Request will never time out
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/executive-list`, config);
                const mappedData = response.data.data.map(item => ({
                    id: item.admin_id,
                    title: item.username,
                }));
                // Include an option for null or empty value
                const optionsWithNull = [
                    { id: null, title: 'Select Executive' },
                    ...mappedData,
                ];
                setExecutiveOptions(optionsWithNull);
                // setExecutiveOptions(mappedData);
            } catch (error) {
                console.error('Error fetching executives:', error);
            }
        };
        fetchDatalist();
    }, []);
    const handleExecutiveChange = (event, newValue) => {
        setSelectedExecutive(newValue);
    };
    const handleStateChange = (event, newValue) => {
        setSelectedState(newValue);
    };
    const handleBrandChange = (event, newValue) => {
        setSelectedBrand(newValue);
    };
    const handleView = (row) => {
        setViewData(row);
        setViewOpen(true);
    };
    const handleCloseView = () => {
        setViewOpen(false);
        setViewData(null);
    };
    const safelyParseJSON = (value, fallback = {}) => {
        if (!value) return fallback;
        // Value is already an object
        if (typeof value === "object") {
            return value;
        }
        try {
            return JSON.parse(value);
        } catch (error) {
            console.error("Invalid JSON value:", value, error);
            return fallback;
        }
    };
    const fetchData = async (from, to, pageNumber, searchQuery) => {
        setIsLoading(true);
        setError(null);
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: `${token}`,
                    adminId: `${adminId}`,
                    userLevel: `${userLevel}`,
                },
                timeout: Infinity,
            };
            const requestData = {
                start_date: appliedFilters?.start_date ?? fromDate,
                end_date: appliedFilters?.end_date ?? toDate,
                pagination: perPage,
                page: page + 1,
                status: appliedFilters?.status ?? status,
                state_id: appliedFilters?.state_id ?? ""
                // search: search,
                // product_brand: selectedBrand,
                // enquiry_source: enquirySource,
                // states: selectedState,
                // executive: selectedExecutive,
                // user_level: userLevel,
                // admin_id: adminId,
            };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/api-responses/brand/16`,
                requestData,
                config
            );
            const apiResponseData = response?.data?.data?.data || [];
            const mappedData = apiResponseData.map((item, index) => {
                /*
                 * Case 1:
                 * enquiry_id exists:
                 * Use new_tractor_enquiries.user data.
                 *
                 * Case 2:
                 * enquiry_id is null, undefined or empty:
                 * Parse request_body and use request_body.user data.
                 */
                const hasEnquiryId =
                    item.enquiry_id !== null &&
                    item.enquiry_id !== undefined &&
                    item.enquiry_id !== "" && Number(item.enquiry_id) !== 0;
                const parsedRequestBody = safelyParseJSON(item.request_body);
                const enquiryData = item.new_tractor_enquiries || {};
                const enquiryUser = enquiryData.user || {};
                const requestUser = parsedRequestBody.user || {};
                const selectedUser = hasEnquiryId
                    ? enquiryUser
                    : requestUser;
                const stateObject = selectedUser.state || {};
                const cityObject = selectedUser.city || {};
                const talukaObject = selectedUser.taluka || {};
                const firstName = selectedUser.first_name || "";
                const lastName = selectedUser.last_name || "";
                const customerName =
                    `${firstName} ${lastName}`.trim() ||
                    item.full_name ||
                    "";
                const tractorData = enquiryData.tractor_table || {};
                const tractorModel = tractorData.tractor_model || {};
                const modelName =
                    tractorData.tractor_name ||
                    tractorModel.tractor_model_name ||
                    item.modelName ||
                    item.model ||
                    parsedRequestBody.enquiry_name ||
                    "";
                return {
                    // For serial number based on current pagination
                    sr_no: page * perPage + index + 1,
                    // Keep API record ID separately when required
                    id: item.id || "",
                    created_at:
                        item.created_at ||
                        enquiryData.created_at ||
                        parsedRequestBody.created_at ||
                        "",
                    upload_type:
                        item.upload_type ||
                        parsedRequestBody.enquiry_name ||
                        "",
                    enquiry_id:
                        item.enquiry_id ||
                        enquiryData.id ||
                        parsedRequestBody.id ||
                        "",
                    model: modelName,
                    user: customerName,
                    email:
                        selectedUser.email ||
                        item.email ||
                        "",
                    mobile:
                        selectedUser.mobile ||
                        item.mobile ||
                        "",
                    state:
                        stateObject.state_name ||
                        selectedUser.state_name ||
                        item.state ||
                        "",
                    city:
                        cityObject.city_name ||
                        selectedUser.city_name ||
                        item.city ||
                        "",
                    taluka:
                        talukaObject.name ||
                        selectedUser.taluka_name ||
                        item.taluka ||
                        "",
                    source:
                        enquiryData.enquiry_from ||
                        item.source ||
                        "",
                    brand:
                        tractorData.brand?.brand_name ||
                        item.brand?.brand_name ||
                        "",
                    request_body:
                        typeof item.request_body === "string"
                            ? item.request_body
                            : JSON.stringify(item.request_body || {}, null, 2),
                    response:
                        typeof item.response === "string"
                            ? item.response
                            : JSON.stringify(item.response || {}, null, 2),
                };
            });
            setData(mappedData);
            setTotalCount(response?.data?.data?.total || 0);
        } catch (error) {
            console.error("Error fetching data:", error);
            if (axios.isCancel(error)) {
                console.error("Request canceled:", error.message);
                return;
            }
            if (error.code === "ECONNABORTED") {
                setError("The request timed out. Please try again.");
            } else if (error.response) {
                console.error("Server Error Details:", error.response.data);
                setError(
                    error.response.data?.message ||
                    `Error: ${error.response.status} - ${error.response.statusText}`
                );
            } else {
                setError("An error occurred while fetching data.");
            }
        } finally {
            setIsLoading(false);
        }
    };
    const source = axios.CancelToken.source();
    // useEffect(() => {
    //     fetchData(perPage, page, search, totalCount, enquirySource);
    //     // Cleanup function
    //     return () => {
    //         source.cancel('Request canceled by cleanup');
    //     };
    // }, [perPage, page, search, totalCount, enquirySource]);
    const sourceRef = useRef(null);
    useEffect(() => {
        fetchData(fromDate, toDate, page, search);
    }, [perPage, page, appliedFilters]);
    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate') {
            setFromDate(value);
        } else if (name === 'toDate') {
            setToDate(value);
        }
    };
    const handleStatusChange = (e) => {
        setStatus(e.target.value);
    };
    const handlePerPageChange = (e) => {
        setPerPage(Number(e.target.value));
    };
    const handlePrevious = () => {
        if (page > 0) {
            setPage(page - 1);
        }
    };
    const handleNext = () => {
        setPage(page + 1);
    };
    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };
    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     setPage(0);
    //     fetchData(fromDate, toDate, selectedExecutive, selectedBrand, selectedState,);
    // };
    const handleSubmit = (e) => {
        e.preventDefault();
        setPage(0);
        setAppliedFilters({start_date: fromDate, end_date: toDate, status, state_id: selectedState?.id ?? ""});
        setOpenSidebar(false);
    };
    const clearForm = () => {
        const today = new Date().toISOString().split('T')[0];
        setFromDate(today);
        setToDate(today);
        setStatus('success');
        setSelectedState(null);
        setPage(0);
        setAppliedFilters({start_date: today, end_date: today, status: 'success', state_id: ''});
        setOpenSidebar(false);
    };
    const handleFinanceRowSelect = (id, checked) => {
        const numericId = Number(id);
        if (!Number.isInteger(numericId) || numericId <= 0) return;
        setSelectedFinanceIds(prev => checked ? [...new Set([...prev, numericId])] : prev.filter(value => value !== numericId));
    };
    const handleFinanceSelectAll = checked => {
        const ids = data.map(row => Number(row.id)).filter(id => Number.isInteger(id) && id > 0);
        setSelectedFinanceIds(prev => checked ? [...new Set([...prev, ...ids])] : prev.filter(id => !ids.includes(id)));
    };
    const handleOpenFinanceDialog = () => {
        if (!selectedFinanceIds.length) return;
        setFinanceError('');
        setFinanceFilters({client_name: 'Tyger', state_id: appliedFilters?.state_id ?? '', start_date: appliedFilters?.start_date ?? fromDate, end_date: appliedFilters?.end_date ?? toDate});
        setFinanceDialogOpen(true);
    };
    const handleSubmitFinance = async () => {
        if (financeSubmitting || !selectedFinanceIds.length) return;
        if (!financeFilters.start_date || !financeFilters.end_date || financeFilters.start_date > financeFilters.end_date) {
            setFinanceError('Please provide a valid start and end date.');
            return;
        }
        const payload = {
            move_type: 1,
            client_name: financeFilters.client_name,
            state_id: financeFilters.state_id === '' ? null : Number(financeFilters.state_id),
            start_date: financeFilters.start_date,
            end_date: financeFilters.end_date,
            move_from: 'apis_leads',
            id_selected: selectedFinanceIds.map(id => ({id}))
        };
        setFinanceSubmitting(true);
        setFinanceError('');
        try {
            const response = await axios.post(`${API_BASE_URL}/api/admin/v2/move-finance-enquiries`, payload, {
                headers: {'Content-Type': 'application/json', Accept: 'application/json', Authorization: `${token}`, adminId: `${adminId}`, userLevel: `${userLevel}`}
            });
            if (response.data?.success === false || response.data?.status === false || response.data?.status === 'fail') throw new Error(response.data?.message || 'Finance enquiry transfer failed.');
            setSelectedFinanceIds([]);
            setFinanceDialogOpen(false);
            await fetchData(fromDate, toDate, page, search);
        } catch (err) {
            setFinanceError(err.response?.data?.message || err.message || 'Unable to move finance enquiries.');
        } finally {
            setFinanceSubmitting(false);
        }
    };
    const columns = [
        {name: 'finance_select', label: 'Select', options: {filter: false, sort: false,
            customHeadLabelRender: () => <Checkbox color="primary" checked={data.length > 0 && data.every(row => selectedFinanceIds.includes(Number(row.id)))} indeterminate={data.some(row => selectedFinanceIds.includes(Number(row.id))) && !data.every(row => selectedFinanceIds.includes(Number(row.id)))} onChange={event => handleFinanceSelectAll(event.target.checked)} />,
            customBodyRenderLite: dataIndex => {
                const row = data[dataIndex];
                return row ? <Checkbox color="primary" checked={selectedFinanceIds.includes(Number(row.id))} onChange={event => handleFinanceRowSelect(row.id, event.target.checked)} /> : null;
            }
        }},
        {
            name: "sr_no",
            label: "S/N",
            options: {
                filter: false,
                sort: false,
            }
        },
        {
            name: "created_at",
            label: "Created At",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "upload_type",
            label: "Upload Type",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "enquiry_id",
            label: "Enquiry ID",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "model",
            label: "Model",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "user",
            label: "Customer Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "email",
            label: "Email",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "mobile",
            label: "Mobile",
            options: {
                filter: true,
                sort: false,
            }
        },
        {
            name: "state",
            label: "State",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "city",
            label: "City",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "taluka",
            label: "Taluka",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "request_body",
            label: "Request Body",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => (
                    <div
                        style={{
                            maxWidth: "350px",
                            maxHeight: "120px",
                            overflow: "auto",
                            whiteSpace: "pre-wrap",
                            fontSize: "12px",
                        }}
                    >
                        {value}
                    </div>
                )
            }
        },
        {
            name: "response",
            label: "Response",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => (
                    <div
                        style={{
                            maxWidth: "350px",
                            maxHeight: "120px",
                            overflow: "auto",
                            whiteSpace: "pre-wrap",
                            fontSize: "12px",
                        }}
                    >
                        {value}
                    </div>
                )
            }
        },
        {
            name: "view",
            label: "View",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    const row = data[dataIndex];
                    return (
                        <IconButton
                            size="small"
                            onClick={() => handleView(row)}
                            style={{
                                color: "#1976d2"
                            }}
                        >
                            <VisibilityIcon />
                        </IconButton>
                    );
                }
            }
        }
    ];
    const CustomToolbarAction = ({ toggleFilter }) => (
        <IconButton aria-label="Filter list" onClick={toggleFilter}>
            <FilterListIcon onClick={toggleSidebar} />
        </IconButton>
    );
    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.shiftKey && event.key === 'F') {
                // Shift + D is pressed, open the sidebar
                setOpenSidebar(true);
            }
        };
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, []);
    const toggleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };
    const options = {
        rowsPerPage: perPage,
        selectableRows: 'none',
        page: page,
        serverSide: true,
        count: totalCount,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setPerPage(tableState.rowsPerPage);
                    setPage(0);
                    break;
                default:
                    break;
            }
        },
        customToolbar: () => <CustomToolbarAction />,
        filter: false,
        filterType: "dropdown",
        responsive: "standard",
        fixedHeader: true,
        fixedSelectColumn: true,
        overflowy: "auto",
        overflowx: "auto",
        rowsPerPageOptions: [10, 50, 100, 1000, 10000, { value: totalCount, label: 'All' }],
        customFilterDialogFooter: (currentFilter, applyNewFilter) => (
            <div>
                <TextField
                    label="Filter Data"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    fullWidth
                />
                <Button onClick={applyNewFilter} variant="contained" color="primary">
                    Apply Filter
                </Button>
                <Button onClick={() => setOpenSidebar(false)} variant="contained" color="secondary">
                    Cancel
                </Button>
            </div>
        ),
    };
    const currentTheme = customTheme(true);
    const classes = useStyles();
    const memoizedData = useMemo(() => data, [data]);
    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Grid container>
                    <Grid item xs={6} style={{ marginTop: "8px" }}>
                        <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>
                            Eicher API Response
                        </Typography>
                    </Grid>
                    <Grid item xs={6} style={{ margin: "auto", padding: "auto", textAlign: "right", marginBottom: "5px" }}>
                        <Button variant="contained" color="primary" disabled={!selectedFinanceIds.length} onClick={handleOpenFinanceDialog}>Move to Finance Enquiry ({selectedFinanceIds.length})</Button>
                    </Grid>
                </Grid>
                <hr className={classes.horizontalline} />
            </Box>
            <MuiThemeProvider theme={currentTheme}>
                {
                    isLoading ? (
                        <LinearProgress />
                    ) : (
                        ""
                    )
                }
                <MUIDataTable
                    title={
                        isLoading ? (
                            <Skeleton animation="wave" />
                        ) : (
                            <Typography className={classes.tabletittle} >
                                Eicher API Response
                            </Typography>
                        )
                    }
                    data={memoizedData}
                    columns={columns}
                    options={options}
                />
            </MuiThemeProvider>
            <Dialog open={financeDialogOpen} onClose={() => !financeSubmitting && setFinanceDialogOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>Move to Finance Enquiry</DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item xs={12}><Typography>Selected API Responses: {selectedFinanceIds.length}</Typography></Grid>
                        <Grid item xs={12}><TextField select fullWidth variant="outlined" label="Client Name" value={financeFilters.client_name} onChange={e => setFinanceFilters(prev => ({...prev, client_name: e.target.value}))}><MenuItem value="Tyger">Tyger</MenuItem></TextField></Grid>
                        <Grid item xs={12}><TextField select fullWidth variant="outlined" label="State" value={financeFilters.state_id} onChange={e => setFinanceFilters(prev => ({...prev, state_id: e.target.value}))}><MenuItem value="">All States</MenuItem>{stateOptions.map(item => <MenuItem key={item.id} value={item.id}>{item.title}</MenuItem>)}</TextField></Grid>
                        <Grid item xs={6}><TextField fullWidth type="date" variant="outlined" label="Start Date" InputLabelProps={{shrink: true}} value={financeFilters.start_date} onChange={e => setFinanceFilters(prev => ({...prev, start_date: e.target.value}))} /></Grid>
                        <Grid item xs={6}><TextField fullWidth type="date" variant="outlined" label="End Date" InputLabelProps={{shrink: true}} value={financeFilters.end_date} onChange={e => setFinanceFilters(prev => ({...prev, end_date: e.target.value}))} /></Grid>
                        <Grid item xs={12}><TextField fullWidth variant="outlined" label="Move From" value="apis_leads" disabled /></Grid>
                        {financeError && <Grid item xs={12}><Typography color="error">{financeError}</Typography></Grid>}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button disabled={financeSubmitting} onClick={() => setFinanceDialogOpen(false)}>Cancel</Button>
                    <Button color="primary" variant="contained" disabled={financeSubmitting || !selectedFinanceIds.length} onClick={handleSubmitFinance}>{financeSubmitting ? 'Submitting...' : 'Submit to Finance'}</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={viewOpen} onClose={handleCloseView} fullWidth maxWidth="md">
                <DialogTitle>
                    Eicher API Response Details
                </DialogTitle>
                <DialogContent dividers>
                    {viewData && (
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption">
                                    ID
                                </Typography>
                                <Typography>
                                    {viewData.id || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption">
                                    Enquiry ID
                                </Typography>
                                <Typography>
                                    {viewData.enquiry_id || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption">
                                    Created At
                                </Typography>
                                <Typography>
                                    {viewData.created_at || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption">
                                    Upload Type
                                </Typography>
                                <Typography>
                                    {viewData.upload_type || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption">
                                    Model
                                </Typography>
                                <Typography>
                                    {viewData.model || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption">
                                    Customer Name
                                </Typography>
                                <Typography>
                                    {viewData.user || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption">
                                    Mobile
                                </Typography>
                                <Typography>
                                    {viewData.mobile || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption">
                                    Email
                                </Typography>
                                <Typography>
                                    {viewData.email || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="caption">
                                    State
                                </Typography>
                                <Typography>
                                    {viewData.state || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="caption">
                                    City
                                </Typography>
                                <Typography>
                                    {viewData.city || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="caption">
                                    Taluka
                                </Typography>
                                <Typography>
                                    {viewData.taluka || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption">
                                    Source
                                </Typography>
                                <Typography>
                                    {viewData.source || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="caption">
                                    Brand
                                </Typography>
                                <Typography>
                                    {viewData.brand || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography
                                    variant="subtitle1"
                                    style={{
                                        fontWeight: 600,
                                        marginTop: "10px",
                                        marginBottom: "5px"
                                    }}
                                >
                                    Request
                                </Typography>
                                <div
                                    style={{
                                        width: "100%",
                                        maxHeight: "250px",
                                        overflow: "auto",
                                        whiteSpace: "pre-wrap",
                                        wordBreak: "break-word",
                                        fontFamily: "monospace",
                                        fontSize: "12px",
                                        background: "#f8f9fa",
                                        padding: "10px",
                                        border: "1px solid #eee",
                                        borderRadius: "4px"
                                    }}
                                >
                                    {viewData.request_body || "-"}
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography
                                    variant="subtitle1"
                                    style={{
                                        fontWeight: 600,
                                        marginTop: "10px",
                                        marginBottom: "5px"
                                    }}
                                >
                                    Response
                                </Typography>
                                <div
                                    style={{
                                        width: "100%",
                                        maxHeight: "250px",
                                        overflow: "auto",
                                        whiteSpace: "pre-wrap",
                                        wordBreak: "break-word",
                                        fontFamily: "monospace",
                                        fontSize: "12px",
                                        background: "#f8f9fa",
                                        padding: "10px",
                                        border: "1px solid #eee",
                                        borderRadius: "4px"
                                    }}
                                >
                                    {viewData.response || "-"}
                                </div>
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleCloseView}
                        variant="outlined"
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Drawer anchor="right" open={openSidebar}
                PaperProps={{
                    style: {
                        width: "100%",
                        maxWidth: 300,
                        padding: "10px"
                    }
                }}
                onClose={() => setOpenSidebar(false)}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>
                            <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={12} >
                            <br />
                            <Typography className={classes.tabletittle} >
                                Filter
                            </Typography>
                        </Grid>
                    </Grid>
                    <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>
                        <div className={classes.root}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Autocomplete options={stateOptions} getOptionLabel={option => option?.title || ''} value={selectedState} onChange={(event, value) => setSelectedState(value)} getOptionSelected={(option, value) => option.id === value.id} renderInput={params => <TextField {...params} placeholder="Select State" variant="outlined" size="small" fullWidth />} />
                                </Grid>
                                <Grid item xs={4} sm={2} lg={12} >
                                    <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />
                                </Grid>
                                <Grid item xs={4} sm={2} lg={12}>
                                    <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />
                                </Grid>
                                {/* Status */}
                                <Grid item xs={4} sm={2} lg={12}>
                                    <select
                                        className={classes.inputform}
                                        name="status"
                                        value={status}
                                        onChange={handleStatusChange}
                                    >
                                        <option value="">All Status</option>
                                        <option value="success">Success</option>
                                        <option value="fail">Fail</option>
                                    </select>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <br />
                    <Grid >
                        <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>
                            {/* <button className={classes.buttonform} type="submit">Fetch Data</button> */}
                            <Button
                                type='submit'
                                style={{ marginRight: "10px" }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ApprovalIcon />}>
                                Apply
                            </Button>
                            <Button
                                type="button" onClick={clearForm}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ClearIcon />}>
                                Clear
                            </Button>
                        </Grid>
                    </Grid>
                    <br />
                </form>
            </Drawer >
        </>
    );
};
export default EicherAPIResponse;








